import { jsx as _jsx } from "react/jsx-runtime";
import { useRouteMatch } from 'react-router-dom';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { CardsContainer, GroupItem } from 'signin-app/groups/group-item';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import * as Selectors from './selectors';
const Groups = () => {
    const match = useRouteMatch();
    const groups = useTypedSelector(Selectors.groups);
    const { isTabletPortraitAndLarger } = useBreakpoints();
    return (_jsx(CardsContainer, { children: groups.map(group => (_jsx(GroupItem, { title: group.title, image: group.image, href: `${match.url}/${group.groupId}`, groupType: 'Children', groupId: group.groupId, alignment: isTabletPortraitAndLarger ? 'vertical' : 'horizontal' }, group.groupId))) }));
};
export default Groups;
